import { QuestionIcon } from '@phosphor-icons/react';
import { Badge, Loader, Tabs } from '@mantine/core';
import { useSupportCasesControllerGetSupportCasesForWorkOrder } from '@/generated/api/support-cases.ts';
import { useMemo } from 'react';
import { WORK_ORDER_AUTO_REFRESH_QUERY_OPTIONS } from '../../autoRefresh.ts';

type SupportCaseTabParams = {
  workOrderId: string;
};

export default function SupportCasesTab({ workOrderId }: SupportCaseTabParams) {
  const supportCases = useSupportCasesControllerGetSupportCasesForWorkOrder(
    workOrderId,
    {
      query: WORK_ORDER_AUTO_REFRESH_QUERY_OPTIONS,
    },
  );

  const caseCount = useMemo(
    () => (supportCases.data?.supportCases ?? []).length,
    [supportCases.data],
  );
  const openCaseCount = useMemo(
    () =>
      (supportCases.data?.supportCases ?? []).filter(
        (sc) => sc.closedAt === null,
      ).length,
    [supportCases.data],
  );

  return (
    <Tabs.Tab
      value="support-cases"
      title="Support Cases"
      aria-label="Support Cases"
      leftSection={<QuestionIcon size={14} />}
      rightSection={
        supportCases.isLoading ? (
          <Loader size="xs" />
        ) : (
          <Badge size="xs" color={openCaseCount ? 'red' : 'gray'}>
            {caseCount}
          </Badge>
        )
      }
    >
      Cases
    </Tabs.Tab>
  );
}
